import { hasAnalyticsConsent } from '@/utils/consent';

const DISPATCHING_METHODS = ['alias', 'logEvent', 'measureEnd', 'measureStart', 'setUserProperties', 'trackEvent'];

/**
 * Gate every network-dispatching method on the shared tracking service.
 *
 * Kept separate from tracking.js so this boundary can be tested without
 * importing the application store and its component graph.
 */
export function guardDispatchers(service) {
  DISPATCHING_METHODS.forEach((name) => {
    if (typeof service[name] !== 'function') {
      return;
    }

    const send = service[name].bind(service);
    service[name] = (...args) => (hasAnalyticsConsent() ? send(...args) : undefined);
  });

  return service;
}
